import React from "react";
import { FormattedMessage } from "react-intl";
import { Icon } from "antd";
import cw from "../../utils/commonwords";
import { Link } from "react-router-dom";

export function HeaderInfo(props) {
  const {
    location,
    numberOfPeople,
    currentGroup,
    totalNumberOfPeople,
    siteLanguage,
    intl,
    parentGroupName,
    pageTitle,
    className,
  } = props;
  return (
    <div className={className}>
      {`${location.pathname}`.endsWith("/everyone") ? (
        <h3>
          {totalNumberOfPeople === 0 ? (
            <FormattedMessage id="Everyone" defaultMessage="Everyone" />
          ) : (
            <React.Fragment>
              {" "}
              <span data-dfs-people-id="number-of-people">
                {/* {numberOfPeople}/ */}
                {parseInt(totalNumberOfPeople).toLocaleString()}
              </span>
              {numberOfPeople === 1 ? (
                <React.Fragment>
                  {" "}
                  <FormattedMessage id="App.Person" defaultMessage={"person"} />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {" "}
                  <FormattedMessage id="App.People" defaultMessage={"people"} />
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </h3>
      ) : (
        <React.Fragment>
          {`${location.pathname}`.includes("/groups/") ? (
            <div className={"groupName"}>
              {parentGroupName && (
                <React.Fragment>
                  <Link
                    data-dfs-people-id={"main-menu-item-system"}
                    to={`/${siteLanguage || "en"}/groups/${
                      currentGroup.parentId
                    }`}
                  >
                    <h3 className={"parentName"}>
                      {intl.formatMessage(cw[parentGroupName])}{" "}
                    </h3>
                  </Link>
                  <Icon style={{ fontSize: 11 }} type="right" />
                </React.Fragment>
              )}
              <h3 style={{ marginLeft: parentGroupName ? 0 : -8 }}>
                <span>{currentGroup.groupName}</span>
              </h3>
            </div>
          ) : (
            <React.Fragment>
              {`${location.pathname}`.includes("/search") ? (
                <div style={{ display: "flex" }}>
                  <h3>
                    <FormattedMessage id="Search" defaultMessage="Search" />
                  </h3>
                </div>
              ) : (
                <h2>{pageTitle}</h2>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
}
